import { useTranslation } from 'react-i18next'

import { getNormalizedTrackingStatusMessage } from '@/parcels/pages/ParcelDetailPage/helpers'

import { getExceptionMessage } from './helpers'

const SubStatusMessage = ({ parcelStatus, normalizedTrackingStatus, exception, statusTime }) => {
  const { t } = useTranslation()
  const exceptionMessage = getExceptionMessage({ exception, statusTime, t })
  const normalizedTrackingStatusMessage = getNormalizedTrackingStatusMessage(parcelStatus, normalizedTrackingStatus)

  const message = exceptionMessage || normalizedTrackingStatusMessage

  if (!message) return null

  return <> - &quot;{t(message)}&quot;</>
}

export default SubStatusMessage
